var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"editor-body"},[_c('editor',{attrs:{"init":_vm.init},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}}),_c('div',{staticClass:"warning-txt"},[_vm._v(_vm._s(_vm.txt))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }